import React from 'react';
import { DollarSign, PenTool, Shirt, CheckSquare, ShoppingBag } from 'lucide-react';
import { Container } from '../Container';
export function TrustBar() {
  const items = [{
    icon: DollarSign,
    text: 'Factory Direct Pricing'
  }, {
    icon: PenTool,
    text: 'Artwork & Mockup Help'
  }, {
    icon: Shirt,
    text: 'Product / Size Samples'
  }, {
    icon: CheckSquare,
    text: 'Approval Process'
  }, {
    icon: ShoppingBag,
    text: 'Team Stores Available'
  }];
  return <div className="bg-gray-100 border-b border-gray-200 py-6" data-id="element-268">
      <Container data-id="element-269">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-270">
          {items.map((item, index) => <div key={index} className="flex items-center justify-center lg:justify-start space-x-3" data-id="element-271">
              <div className="bg-white p-2 rounded-full shadow-sm text-pts-red" data-id="element-272">
                <item.icon className="h-5 w-5" data-id="element-273" />
              </div>
              <span className="font-semibold text-sm text-gray-800 leading-tight" data-id="element-274">
                {item.text}
              </span>
            </div>)}
        </div>
      </Container>
    </div>;
}